import {
  useCallback, useContext, useEffect, useState,
} from 'react';
import { AppContext } from '../../../providers/authProvider';
import { useGenerateReport } from './render';

const useDetailsShower = (reportId, schema, settings) => {
  const { auth } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [results, setResults] = useState(null);

  const onLoadStart = useCallback(() => {
    setLoading(true);
    setErr(null);
  }, []);
  const onLoadEnd = useCallback(() => {
    setLoading(false);
  }, []);
  const onError = useCallback((e) => setErr(e), []);
  const {
    groups, selections, orders, filters, columns, params,
  } = settings;

  const onGenerateReport = useGenerateReport(
    reportId,
    auth,
    groups,
    selections,
    orders,
    filters,
    columns,
    params,
    onLoadStart,
    onLoadEnd,
    setResults,
    onError,
  );

  useEffect(
    () => onGenerateReport.onGenerateReport(),
    // eslint-disable-next-line
    []);

  return {
    loading,
    err,
    results,
  };
};

export default useDetailsShower;
